import {
  isArray,
  isObject,
} from '@/utils/validator'

function isVNode (obj) {
  const r = isObject(obj) && Object.keys(obj).includes('componentOptions')

  return r
}

export default {
  props: {
    vnode: {
      type: [
        Object,
        String,
        Function,
        Array,
      ],
    },
  },

  created () {
  },

  render (h) {
    // console.log(this.config, 'sssss')
    const vnode = isArray(this.vnode) ? this.vnode[0] : this.vnode

    if (isVNode(vnode)) {
      return vnode
    }
  },
}
